import React from "react";

class LinkReplacementBlock extends React.Component {
  state = {
    copied: false,
  };

  step1Code = `\u003Cscript>
    var imported = document.createElement('script');
    imported.src = 'https://${window.location.host}/api/LinkReplacement/${this.props.loggedInUser?.id}.js';
    document.head.appendChild(imported);
\u003C/script>`;

  step2Code = `\u003C!DOCTYPE HTML>
\u003CHTML>
  \u003CBODY>
    ...
    \u003Cscript>
      var imported = document.createElement('script');
      imported.src = 'https://${window.location.host}/api/LinkReplacement/${this.props.loggedInUser?.id}.js';
      document.head.appendChild(imported);
    \u003C/script>
    ...
  \u003C/BODY>`;

  handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(this.step1Code.replaceAll("\\u003C", "<"));
      this.setState({ copied: true });
      // match your ShareBlock’s short-lived feedback
      setTimeout(() => this.setState({ copied: false }), 500);
    } catch {
      // Fallback for older browsers
      const ta = document.createElement("textarea");
      ta.value = this.step1Code.replaceAll("\\u003C", "<");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        this.setState({ copied: true });
        setTimeout(() => this.setState({ copied: false }), 500);
      } finally {
        document.body.removeChild(ta);
      }
    }
  };

  render() {
    // Modal-friendly inline styles, brand font
    const s = {
      wrap: {
        maxWidth: 860,
        margin: "0 auto",
        padding: "0 16px",
        fontFamily: "'urbanist', sans-serif",
        lineHeight: 1.5,
        color: "#0f172a",
      },
      h1: { fontSize: 24, margin: "0 0 8px", fontWeight: 700 },
      h2: { fontSize: ["sm"].includes(this.props.deviceSize) ? "13px" : "14px", margin: "8px 0 -6px", fontWeight: 700 },
      p: { margin: "8px 0", fontSize: ["sm"].includes(this.props.deviceSize) ? "13px" : "14px", lineHeight: ["sm"].includes(this.props.deviceSize) ? "1.1rem" : "1.1rem" },
      card: {
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        padding: "6px 16px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
      },
      codeWrap: {
        background: "#0b1020",
        color: "#e5e7eb",
        border: "1px solid #1f2937",
        borderRadius: 12,
        marginTop: 8,
      },
      codeHeader: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "8px 8px 0 8px",
        gap: 8,
      },
      codeScroll: {
        overflowX: "auto",
        padding: "8px 14px 14px 14px",
        borderRadius: "0 0 12px 12px",
      },
      code: {
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        fontSize: 13,
        whiteSpace: "pre",
        display: "block",
      },
      small: { fontSize: 13, color: "#334155" },
      // Optional: keep the “btn” sizing tidy in tight modals without overriding your brand styles
      btnTight: { padding: "6px 10px", lineHeight: 1.2, fontSize: 12, fontWeight: 600, background: "#da4100", color: "white", width: "50px" },
    };

    const renderCopyLabel = () =>
      this.state.copied ? <i className="fas fa-clipboard-check" aria-hidden="true"></i> : "Copy";

    return (
      <div style={s.wrap}>
            <h1 className={`${["sm"].includes(this.props.deviceSize) ? "mb-2" : "mb-3"} ml-2`} style={s.h1}>RockPorch LinkSwap</h1>

        <div style={s.card}>
          <h2 style={s.h2}>What It Is?</h2>
          <p style={s.p}>
            RockPorch LinkSwap is a tiny piece of JavaScript that does one powerful thing: it finds qualifying brand links and affiliate links on your site and automatically swaps them for your RockPorch commissionable links.
          </p>

           <h2 style={s.h2}>How It Works</h2>
                <div style={{ textAlign: "left" }}>
                    <ol
                        style={{
                            ...s.p,
                            textAlign: "left",
                            paddingLeft: 0,
                            marginLeft: 0,
                            listStylePosition: "inside",
                        }}
                    >
                        <li><span style={{ marginLeft: "3px" }}>Copy the code snippet.</span></li>
                        <li>
                            <span style={{ marginLeft: "0px" }}>Paste it just before the closing <code>&lt;/body&gt;</code> tag on your site.</span>
                        </li>
                    </ol>

                    <p style={{ ...s.p, textAlign: "left", margin: "-5px 0 -7px 0" }}>Once the code is live, it:</p>

                    <ul
                        style={{
                            ...s.p,
                            textAlign: "left",
                            paddingLeft: 0,
                            marginLeft: 0,
                            listStylePosition: "inside",
                        }}
                    >
                        <li><span style={{ marginLeft: "-8px" }}>Scans your site for direct brand and affiliate links</span></li>
                        <li><span style={{ marginLeft: "-8px" }}>Replaces qualifying ones with your RockPorch commissionable links</span></li>
                        <li><span style={{ marginLeft: "-8px" }}>Your content earns more while you do less</span></li>
                    </ul>
                </div>

        </div>

        <div style={{ height: 16 }} />

        <div style={s.card}>
          <p style={{ ...s.p, fontWeight: 700 }}>Step 1 — Copy this snippet:</p>
          <div style={s.codeWrap} role="region" aria-label="Step 1 code block">
            <div style={s.codeHeader}>
              <button
                className="btn"
                style={s.btnTight}
                onClick={this.handleCopy}
                aria-label="Copy code"
                type="button"
              >
                {renderCopyLabel()}
              </button>
            </div>
            <div style={s.codeScroll}>
              <code style={s.code}>
                {this.step1Code
                  // show the raw tags in the UI
                  .replaceAll("\\u003C", "<")}
              </code>
            </div>
          </div>

          <p style={{ ...s.p, marginTop: 16 }}>
            <strong>Step 2 —</strong> Paste the snippet into your site template just before the{" "}
            <code>&lt;/body&gt;</code> tag. If you need help, please visit our Support Center.
            Here’s how it should look:
          </p>

          <div style={s.codeWrap} role="region" aria-label="Step 2 code block">
            <div style={s.codeScroll}>
              <code style={s.code}>
                {this.step2Code
                  // show the raw tags in the UI
                  .replaceAll("\\u003C", "<")}
              </code>
            </div>
          </div>

          <p style={{ ...s.p, ...s.small, marginTop: 12 }}>
            Tip: Place it in your global layout or template so it loads on every page that may
            contain qualifying links.
          </p>
        </div>
      </div>
    );
  }
}

export default LinkReplacementBlock;
